<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <button
        type="button"
        class="attachment-preview-button"
        :class="{
          'attachment-preview-button--compact': compact,
          'attachment-preview-button--plain': plain
        }"
        :aria-label="tooltipText"
        :disabled="isDisabled"
        v-bind="attrs"
        v-on="on"
        @click="emitPreview"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          :size="compact ? 14 : 16"
          :width="2"
          color="primary"
        />
        <v-icon v-else :small="compact" color="#3B5FDB">mdi-eye-outline</v-icon>
      </button>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
import { normalizeAttachmentForPreview } from '@/helpers/attachmentPreview'

export default {
  name: 'AttachmentPreviewButton',

  props: {
    attachment: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    previewableAttachment() {
      return normalizeAttachmentForPreview(this.attachment?.file || this.attachment)
    },
    isPreviewable() {
      return Boolean(
        this.previewableAttachment?.file_type === 'forge' ||
        this.previewableAttachment?.pathmedia?.path ||
        this.previewableAttachment?.pathdoc?.path ||
        this.previewableAttachment?.forge_file?.translated
      )
    },
    isDisabled() {
      return this.disabled || this.loading || !this.isPreviewable
    },
    tooltipText() {
      return this.isPreviewable ? 'Previsualizar archivo' : 'Vista previa no disponible'
    }
  },

  methods: {
    emitPreview() {
      if (!this.isDisabled) this.$emit('preview', this.previewableAttachment)
    }
  }
}
</script>

<style scoped>
.attachment-preview-button {
  align-items: center;
  background: #EEF2FF;
  border: 0;
  border-radius: 7px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  margin: 0;
  min-width: 32px;
  padding: 4px;
  vertical-align: middle;
  transition: background 0.12s;
}

.attachment-preview-button:hover:not(:disabled) {
  background: #DDE5F9;
}

.attachment-preview-button:disabled {
  cursor: default;
  opacity: 0.45;
}

.attachment-preview-button--compact {
  height: 28px;
  min-width: 28px;
  padding: 2px;
}

.attachment-preview-button--plain {
  background: transparent;
  border-radius: 0;
  margin: 4px;
}

.attachment-preview-button--plain:hover:not(:disabled) {
  background: transparent;
}
</style>
